import { useModel, useParams } from "@bcm-dev/bcms-vite";
import { ContentSubheaderView } from "components/shared";
import ExternalIframe from 'components/shared/containers/ExternalIframe';
import PageContainer from 'components/shared/containers/PageContainer';
import { CenterContentContainer } from 'components/shared/containers/PageLayoutContainer';
import ContentHeaderView from 'components/shared/views/ContentHeaderView';
import PageContentView from 'components/shared/views/PageContentView';
import React from 'react';
import "./styles.css";

/**
 * @function ZellePage
 * @return {React.Component}
 * @note - Branding for this page is being added to the window object so captures can utilize the set value in state code
 * @exported true
 * @description The main component for ZellePage
 */
export default function ZellePage(props) {
  const { profileType, RXP17LandingPage } = useParams();

  // Branding options needed for captures
  const options = useModel().branding.options;
  window.BRANDING = { "zle_abi22" : options.zle_abi22 };
  const subheaderText = options.zelle_subheader_abi22;
  const hasSubheaderText = subheaderText ? true : false;

  let hasRXP17LandingPage = RXP17LandingPage ? true : false;
  const RXP17LandingPageProp = hasRXP17LandingPage ? { RXP17LandingPage: RXP17LandingPage } : {};

  const mabiBranding = window.mabi23Branding;
  const option = mabiBranding
    ? mabiBranding.options.integrated_page_header_mabi23
    : options.integrated_page_header_abi22;
  const showHeader = option !== "false";

  let zelleProfileType = "personal";
  const zellePersonal = options.zle_courseID_abi22;
  const zelleBusiness = options.zlebusiness_cid_abi22;
  const hasZelleCourse = zellePersonal !== null || zelleBusiness !== null;

  if (hasZelleCourse) {
    if (zellePersonal !== null) {
      zelleProfileType = "personal";
    } else if (zelleBusiness !== null) {
      zelleProfileType = "business";
    }
  } else {
    zelleProfileType = profileType;
  }

  return (
    <PageContainer className="zelle-page integrated-product-page" ignoreTrigger={ true }>
      <PageContentView>
        <CenterContentContainer>
          { showHeader && <ContentHeaderView text={<div className="flex-container"><p>Zelle</p><span className="r-mark">&reg;</span></div>} /> }

          { hasSubheaderText && <ContentSubheaderView text={ subheaderText } /> }
          <div className="iframe-container flex-container flex-horizontal justify-center">
            {/* iFrame for Zelle goes here */}
            <ExternalIframe className="zelle-iframe" demo="ZLE" { ...RXP17LandingPageProp } zleProfileType={ zelleProfileType !=="business"?"personal":"business" } key="ZellePage"/>      
          </div>    
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  );
}
